const DEBUG_MODE = false//process.env.NODE_ENV !== 'production';
const IS_LIVE = true

const BASE_URL = !IS_LIVE
  ? "http://demo.myetrade.com.my/cts-bidor/api/"
  : "https://bidorsentral.com.my/cts-bidor/api/";

const PAYMENT_GATEWAY_URL = !IS_LIVE
  ? "http://demo.myetrade.com.my/cts-bidor/"
  : "https://bidorsentral.com.my/cts-bidor/";

const PDF_URL = !IS_LIVE
  ? "http://demo.myetrade.com.my/cts-bidor/consumer/download-boarding"
  : "https://bidorsentral.com.my/cts-bidor/consumer/download-boarding";
// const BASE_URL = "/cts-kampar/api/";
const MYE_TOKEN = !IS_LIVE ? "bXlldHJhZGVAeHlyZW9uIQ==" : "23453fe89036e40fcc879672e0865a7b";
//const MYE_TOKEN = "23453fe89036e40fcc879672e0865a7b";
const MYE_CLIENT = !IS_LIVE ? "xyr888%" : "376xyr%";
//const MYE_CLIENT = "376xyr%";
// const CLIENT_ID = "BIDOR/MOBILE";
const CLIENT_ID = "BIDOR/INET";
const MAX_PAX = 6;
const GUEST_ID = 'GUEST';

const WEBURL = !IS_LIVE ? "http://test.bidorsentral.com.my/" : "http://bidorsentral.com.my/"
const DUMMY = false;
const TERMS_AND_CONDITIONS_URL = WEBURL + "terms_and_conditions"
const PRIVACY_POLICY_URL = WEBURL + "privacy_policy"
const POLICY_URL = WEBURL + "ticketing_policy"
const DEFAULT_FROM_DESTINATION = { stationCode: 'BDR', stationName: 'BIDOR', region: 'Central' };
export {
  DEBUG_MODE,
  BASE_URL,
  PAYMENT_GATEWAY_URL,
  PDF_URL,
  MYE_TOKEN,
  MYE_CLIENT,
  CLIENT_ID,
  MAX_PAX,
  TERMS_AND_CONDITIONS_URL,
  PRIVACY_POLICY_URL,
  POLICY_URL,
  DEFAULT_FROM_DESTINATION,
  DUMMY,
  GUEST_ID
};
